import styled from 'styled-components';

export const ReactionWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  padding: 0 0 16px 64px;
  cursor: pointer;
`;

export const ReactionItems = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.subText};

  & > * {
    display: flex;
    align-items: center;
    gap: 2px;
    cursor: pointer;
  }
`;
